const CITY_ALIASES = {
  bangalore: 'Bengaluru', banglore: 'Bengaluru', bengaluru: 'Bengaluru',
  mysore: 'Mysuru', mysuru: 'Mysuru',
  bombay: 'Mumbai', mumbai: 'Mumbai',
  calcutta: 'Kolkata', kolkata: 'Kolkata',
  madras: 'Chennai', chennai: 'Chennai',
  vizag: 'Visakhapatnam', visakhapatnam: 'Visakhapatnam',
  trivandrum: 'Thiruvananthapuram', thiruvananthapuram: 'Thiruvananthapuram',
  cochin: 'Kochi', kochi: 'Kochi',
  hubli: 'Hubballi', hubl: 'Hubballi', hubballi: 'Hubballi', hubbali: 'Hubballi',
  pune: 'Pune', poona: 'Pune',
  gurgaon: 'Gurugram', gurugram: 'Gurugram',
};

const NOISE_WORDS = /\b(urban|rural|district|city|only|and near by|near by)\b/gi;

const KNOWN_CITIES = [
  'Bengaluru','Mumbai','Delhi','Hyderabad','Chennai','Kolkata','Pune','Ahmedabad','Jaipur','Surat',
  'Lucknow','Kanpur','Nagpur','Indore','Bhopal','Patna','Vadodara','Ghaziabad','Ludhiana','Agra',
  'Nashik','Faridabad','Meerut','Rajkot','Varanasi','Srinagar','Aurangabad','Dhanbad','Amritsar',
  'Ranchi','Coimbatore','Jabalpur','Gwalior','Vijayawada','Jodhpur','Madurai','Raipur','Kota',
  'Chandigarh','Guwahati','Mysuru','Hubballi','Mangaluru','Belagavi','Kochi','Thiruvananthapuram',
  'Visakhapatnam','Noida','Gurugram','Thane','Navi Mumbai','Dehradun','Bhubaneswar','Jamshedpur',
  'Udaipur','Ajmer','Tiruchirappalli','Salem','Warangal','Vellore','Kozhikode','Thrissur',
];

const editDistance = (a, b) => {
  const dp = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
  for (let j = 1; j <= b.length; j++) dp[0][j] = j;
  for (let i = 1; i <= a.length; i++)
    for (let j = 1; j <= b.length; j++)
      dp[i][j] = Math.min(
        dp[i - 1][j] + 1,
        dp[i][j - 1] + 1,
        dp[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)
      );
  return dp[a.length][b.length];
};

const titleCase = (s) => s.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

// "Bangaluru, karnatak" -> "Bengaluru, Karnatak"
export const suggestCity = (raw) => {
  if (!raw) return '';
  const [first, ...rest] = raw.split(',');
  const cleaned = first.replace(NOISE_WORDS, '').replace(/\s+/g, ' ').trim();
  if (!cleaned) return raw.trim();
  const key = cleaned.toLowerCase();

  let city = CITY_ALIASES[key] || KNOWN_CITIES.find((c) => c.toLowerCase() === key);
  if (!city) {
    let best = null, bestD = Infinity;
    for (const c of KNOWN_CITIES) {
      const d = editDistance(key, c.toLowerCase());
      if (d < bestD) { bestD = d; best = c; }
    }
    city = bestD <= (key.length <= 5 ? 1 : 2) ? best : titleCase(cleaned);
  }
  const tail = rest.map((s) => s.trim()).filter(Boolean).map(titleCase);
  return [city, ...tail].join(', ');
};

// Takes the raw location STRING (not the whole record)
export const hasWrongLocation = (raw) => !!raw && suggestCity(raw) !== raw;